const state = {
  style: {
    primaryColor: '',
    primaryColorDark: '',
    secondaryColor: '',
  }
}

const getters = {
  getColor (state) {
    const { primaryColor, primaryColorDark, secondaryColor } = state.style;
    return { primaryColor, primaryColorDark, secondaryColor };
  } 
}

const mutations = {
  setColor (state, data) {
    // console.log(data)
    const { primaryColor, primaryColorDark, secondaryColor } = data;
    // console.log(primaryColor, primaryColorDark, secondaryColor)

    state.style = {
      ...state.style,
      primaryColor,
      primaryColorDark,
      secondaryColor,
    }
  }
}

const actions = {
  setColor (context, data) { 
    context.commit('setColor', data)

    let promise = new Promise((resolve, reject) => {
      if(!data) {
        reject();
      }

      context.commit('setColor', data)

      resolve();
    }) 

    return promise;
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
